import {mapGetters, mapActions} from 'vuex'
export default {
    computed: {
        ...mapGetters({
            filteredDocuments: 'DocumentStore/getFilteredDocuments'
        })
    },

    methods: {
        ...mapActions({
            setIngredientsInDocumentStore: 'DocumentStore/setIngredients'
        }),

        async gatherIngredients() {
            var ingredients = []
    
            this.documents.forEach(document => {
                if(document.activeingredients.length) {
                    document.activeingredients.forEach(ingredient => {
                        if(!ingredients.includes(ingredient.title)) {
                            ingredients.push(ingredient.title)
                        }
                    })
                }
            })
    
            ingredients = ingredients.sort((a, b) => a.localeCompare(b))
    
            this.setIngredientsInDocumentStore(ingredients)
        }
    }
}